// takedaspark
import i18n from '../../i18n/i18n'
import takedabg from '@/assets/images/login/takedabg.png'

const takedaspark = {
  title: 'takedaspark',
  bg: takedabg,
  id: 'takedaspark',
  logo: '',
  unionId: 'takedaspark',
  slogan: '世界',
  sloganFromLocal: 'welcomeTakedaspark',
  logoUrl: '',
  termsOfUse: '',
  signInMethods: ['phone'],
  signInMode: ['signIn', 'signUp'],
  languageInfo: ['cn'],
  position: 'center',
  socialConnectors: [],
  className: 'takedaspark-wrap',
  defaultContainer: 'porsche-container',
  isSupportRegion: false, // 是否支持区域
  needSlientLogin: false, // 是否需要静默登录
  selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
  isAutoLogin: true, // 是否自动登录
  hasOwnSms: true, // 是否有自己的短信服务
  isMergeLoginAndRegister: true, // 是否合并登录/注册
  hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
  Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
  OwnTipsTitle: '', // 自己的提示内容
  OwnTipsSubTitle: '', // 如果有提示的话，提示内容
  OwnTipsContent: '', // 如果有提示的话，提示内容
  OwnMoreTips: '', // 是否有更多提示
  isShowRegion: true, // 是否显示区域
  isNeedTagedSource: true, // 是否需要标记来源
  hasCustomLoginPage: true, // 是都有自定义的登录页面
  hasFooter: true, // 是否有底部
  hasOwnFonts: false, // 是否有自己的字体
  hasOwnThemeStyle: true, // 是否有自己的主题样式
  fontNames: '', // 字体名称
  agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
  agreeAnd: i18n.t('login.register.andPorsche718'),
  isNeedPassSource: true, // 是否需要传递来源
  isNeedTitle: false, // 是否需要显示标题
  isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
  smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
}

export default takedaspark
